<template>
  <div class="input-group">
    <label>{{ label }}</label>
    <input
      type="date"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String
  }
}
</script>
